<ion-card>
  <ion-card-header>
    <ion-card-title>Feladatok</ion-card-title>
    <ion-card-subtitle>
      Szignálás, ügyintézés, véleményezés, jóváhagyás. Több felelősnél köröztetés:
      alapból sorban haladnak, tehát a következő csak akkor kapja meg, ha az előző lezárta.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-szamok" *ngIf="munkaasztal">
      <div class="ikt-szam">
        <div class="ertek">{{ munkaasztal.nyitott_feladat }}</div>
        <div class="cimke">nyitott feladatom</div>
      </div>
      <div class="ikt-szam" [class.figyelem]="munkaasztal.lejart_feladat > 0">
        <div class="ertek">{{ munkaasztal.lejart_feladat }}</div>
        <div class="cimke">lejárt határidő</div>
      </div>
      <div class="ikt-szam" [class.figyelem]="munkaasztal.atvetelre_var > 0">
        <div class="ertek">{{ munkaasztal.atvetelre_var }}</div>
        <div class="cimke">átvételre vár</div>
      </div>
      <div class="ikt-szam">
        <div class="ertek">{{ munkaasztal.nalam_levo_peldany }}</div>
        <div class="cimke">nálam lévő példány</div>
      </div>
    </div>

    <ion-segment [(ngModel)]="nezet" mode="ios" (ionChange)="nezetValt($any($event.detail.value))">
      <ion-segment-button value="sajat"><ion-label>Rám bízva</ion-label></ion-segment-button>
      <ion-segment-button value="mind"><ion-label>Mind</ion-label></ion-segment-button>
    </ion-segment>

    <div class="ikt-fejsor">
      <ion-button size="small" (click)="ujNyitva = !ujNyitva">
        <ion-icon slot="start" name="add-outline"></ion-icon>Feladat kiadása
      </ion-button>
    </div>

    <!-- Új feladat / köröztetés -->
    <div *ngIf="ujNyitva" style="border:1px solid var(--ion-color-light-shade,#ddd);border-radius:8px;padding:10px;margin-bottom:12px">
      <div class="ikt-fejsor">
        <ion-select label="Ügyirat" label-placement="stacked" interface="popover" [(ngModel)]="uj.targy_id">
          <ion-select-option *ngFor="let u of ugyiratok" [value]="u.id">
            {{ u.iktatoszam }} – {{ u.targy }}
          </ion-select-option>
        </ion-select>
        <ion-select label="Típus" label-placement="stacked" interface="popover" [(ngModel)]="uj.tipus">
          <ion-select-option *ngFor="let t of TIPUSOK" [value]="t.kulcs">{{ t.nev }}</ion-select-option>
        </ion-select>
        <ion-input label="Megnevezés" label-placement="stacked" [(ngModel)]="uj.cim"
                   style="max-width:320px"></ion-input>
        <ion-input label="Határidő" label-placement="stacked" type="date" [(ngModel)]="uj.hatarido"></ion-input>
        <ion-select label="Prioritás" label-placement="stacked" interface="popover" [(ngModel)]="uj.prioritas">
          <ion-select-option value="alacsony">alacsony</ion-select-option>
          <ion-select-option value="normal">normál</ion-select-option>
          <ion-select-option value="surgos">sürgős</ion-select-option>
        </ion-select>
      </div>
      <div class="ikt-fejsor">
        <ion-select label="Felelős(ök)" label-placement="stacked" [multiple]="true" [(ngModel)]="uj.felelosok"
                    style="max-width:340px">
          <ion-select-option *ngFor="let u of ugyintezok" [value]="u.azonosito">{{ u.nev }}</ion-select-option>
        </ion-select>
        <ion-checkbox labelPlacement="end" [checked]="uj.parhuzamos"
                      (ionChange)="uj.parhuzamos = $event.detail.checked">
          Egyszerre mindenkinek (nem sorban)
        </ion-checkbox>
        <ion-button size="small" (click)="kiad()">Kiadás</ion-button>
      </div>
      <ion-textarea label="Leírás" label-placement="stacked" rows="2" [autoGrow]="true"
                    [(ngModel)]="uj.leiras"></ion-textarea>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Feladat</th><th>Ügyirat</th><th>Típus</th><th>Felelős</th>
              <th class="szam">Határidő</th><th>Állapot</th><th>Művelet</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of feladatok">
            <td>
              <b>{{ f.cim }}</b>
              <div style="font-size:.76rem;color:var(--ion-color-medium-shade,#6b7280)" *ngIf="f.korozes">
                köröztetés {{ f.sorrend + 1 }}. lépés
              </div>
            </td>
            <td class="iktszam" (click)="ugyiratra(f)" style="cursor:pointer">{{ f.iktatoszam }}</td>
            <td>{{ f.tipus }}</td>
            <td>{{ f.felelos_nev || f.felelos }}</td>
            <td class="szam">{{ f.hatarido || '—' }}</td>
            <td>
              <ion-badge [color]="allapotSzin(f)">
                {{ f.allapot }}<span *ngIf="f.lejart && f.allapot !== 'kesz'"> · lejárt</span>
              </ion-badge>
            </td>
            <td>
              <ion-button size="small" fill="clear" *ngIf="f.allapot === 'uj'"
                          (click)="allapot(f, 'folyamatban')">Elkezdem</ion-button>
              <ion-button size="small" fill="clear" color="success"
                          *ngIf="f.allapot === 'uj' || f.allapot === 'folyamatban'"
                          (click)="allapot(f, 'kesz')">Kész</ion-button>
              <ion-button size="small" fill="clear" color="danger"
                          *ngIf="f.allapot === 'uj' || f.allapot === 'folyamatban'"
                          (click)="allapot(f, 'elutasitva')">Elutasít</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!feladatok.length">Nincs megjeleníthető feladat.</div>
    </div>
  </ion-card-content>
</ion-card>
